import React from 'react';
import DocumentHead from '../../shared/components/DocumentHead';
import { RoutePath } from '../../shared/enums/RoutePath';
import PrimarySection from '../../shared/components/primary-section/PrimarySection';
import OrderedList from '../../shared/components/ordered-list/OrderedList';
import { userPrivacyInfo } from './userPrivacyInfo';
import { ControlSize } from '../../shared/enums/ControlSize';

const UserPrivacy: React.FC = () => {
  return (
    <div className="UserPrivacy">
      <DocumentHead path={RoutePath.UserPrivacy} />

      <PrimarySection header="User ID Privacy Policy">
        <OrderedList items={userPrivacyInfo} size={ControlSize.Large} isItemTitleHighlighted />
      </PrimarySection>
    </div>
  );
};

export default UserPrivacy;
